import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn helper: join class names, later Tailwind classes win over earlier conflicting ones */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
